module.exports = __webpack_public_path__ + "media/images/common/support2-fa14d3258e526401481ee6bc226a120e.png";